import React from "react";
import { useSelector } from "react-redux";

import { Table } from "../../../../components/ui";
import { COMPLIANCE_PROFILE_PNL_TABLE_COLUMNS } from "../../../ComplianceSearch/components/PnLCalculator/constants";

const CurrentPNL: React.FC = () => {
  const {
    mainData: { data, isLoading },
  } = useSelector((state) => state.fundedComplianceProfile);

  return (
    <div>
      <Table
        theadTitle="Current PNL"
        csv_table_name="Current PNL"
        data={data.pnl}
        loading={isLoading}
        extractKey={(r) => r.compliance_entries_id}
        columns={COMPLIANCE_PROFILE_PNL_TABLE_COLUMNS}
        noResultsMessage="There is no PNL data"
      />
    </div>
  );
};

export default CurrentPNL;
